import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";

export class SaveCKLeverantorCommand extends BasicCommand<SaveCKLeverantorCommand> {
    get primaryKey(): IPrimaryKey<SaveCKLeverantorCommand> {
        return {
            id: this.id
        };
    }
    id: number;
    parentCKLeverantorId?: number;
    doljForKundorder: boolean;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SaveCKLeverantorCommand";
    constructor(id: number,
        doljForKundorder: boolean,
        parentCKLeverantorId?: number) {
        super(SaveCKLeverantorCommand.$type, "ckLeverantor", CommandType.Replace);
        this.id = id;
        this.doljForKundorder = doljForKundorder;
        this.parentCKLeverantorId = parentCKLeverantorId;
    }
}
